import { memo } from 'react';
import { Chip, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import type { ChipProps } from '@mui/material';

const useStyles = makeStyles({ name: 'Tip' })((theme) => ({
  root: {
    borderRadius: theme.radii.large,
    minHeight: theme.spacing(3),
    height: 'auto',
    whiteSpace: 'normal',

    '& > .MuiChip-label': {
      whiteSpace: 'normal',
    },
  },
}));

interface TipProps {
  readonly label: string;
  readonly tipText: string;
  readonly id?: string;
  readonly linkTo?: string;
}

export const Tip = memo<TipProps & ChipProps>(({
  label, id, tipText, linkTo, ...restProps
}) => {
  const { classes } = useStyles();

  if (!linkTo) {
    return (
      <Chip
        component="span"
        color="secondary"
        size="small"
        className={classes.root}
        label={(
          <Typography
            variant="caption"
            color="textSecondary"
          >
            <strong>
              {label}
            </strong>

            {' '}

            {tipText}
          </Typography>
        )}
        {...restProps}
      />
    );
  }

  return (
    <Chip
      id={id}
      component="a"
      color="secondary"
      href={linkTo}
      target="_blank"
      rel="noopener noreferrer"
      size="small"
      className={classes.root}
      clickable
      label={(
        <Typography
          variant="caption"
          color="textSecondary"
        >
          <strong>
            {label}
          </strong>

          {' '}

          <u>
            {tipText}
          </u>
        </Typography>
      )}
      {...restProps}
    />
  );
});
